module.exports = __webpack_public_path__ + "img/excel.44f63bb1.svg";